import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export type Options = {
  period: number
}

export type Attrs = Options

export class CCIConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Cci
  static abbreviation = 'cci'
  static label = 'Commodity Channel Index'
  static shortLabel = 'CCI'
  static description =
    "The Commodity Channel Index (CCI) measures the deviation of a security's price from its statistical mean, helping to identify overbought and oversold conditions, as well as potential trend reversals."

  static optionsOrder = ['period'] as const
  static optionsLabels = { period: 'Period' }
  static inputsOrder = this.optionsOrder
  static inputsLabels = this.optionsLabels
  static calculatedValuesOrder = ['cci'] as const
  static calculatedValuesLabels = {
    cci: 'CCI',
  }

  static defaultCalculatedValueOption = this.calculatedValuesOrder[0]
}
